import React from 'react';
import Sidebar from '../Home/Sidebar/Sidebar';
import Footer from '../Shared/Footer/Footer';
import Menubar from '../Shared/Menubar/Menubar';
import BlogDetails from './BlogDetails';
import blog1 from '../../images/web-tools.jpg'
import blog2 from '../../images/HTML-Tag.jpg'
import blog3 from '../../images/prepare.jpg'

const Blogs = () => {
    const blogDetail =[
        {
            headline: "Front end developers tools & my experience",
            photo: blog1,
            link:"https://ahmedrazon338.medium.com/all-about-know-to-front-end-developers-tools-my-experience-ae968891a3f7",
            body:"To become a front end developer or full-stack developer there are key tools used by all developers. What if these tools don’t exist life become....."
        },
        {
            headline: "Prepare yourself for interview",
            photo: blog3,
            link: "https://ahmedrazon338.medium.com/prepare-for-interview-for-web-developer-76f321f1cae",
            body:"Prepare for your next job in a front-end developer position. In this article, I’ll give some tips that would help your interview. (this is part ...."
        },
        {
            headline: "Most important HTML tags list",
            photo: blog2,
            link: "https://ahmedrazon338.medium.com/most-important-html-tags-listed-down-by-a-web-developer-3156c66cc21a",
            body: "Do you know how many HTML tags exist? Maybe or not. Whatever, if you are a web developer, you don’t have to know all these....."
        }
    ]
    return (
        <div>
            <div className="row">
                <div className="col-md-1">
                    <Sidebar/>
                </div>
                <div className="col-md-10 row">
                    <Menubar/>
                    <div className="col-md-12 row text-center mt-5 justify-content-center">
                        {
                            blogDetail.map(blog=> <BlogDetails blog={blog}></BlogDetails>)
                        }
                    </div>
                    <Footer/>
                </div>
                <div className="col-md-1">

                </div>
            </div>
        </div>
    );
};

export default Blogs;